import {
  ReportType,
  ScoringForDirectReportsResponse,
  SettingsPeriod,
  DirectReportScoringData
} from "@/entities/reporting/types";
import { UserData } from "@/entities/users/types";
import { ScoringTableDataRow } from "@/components/controls/DataTable/ScoringTable";
import { createScoringTableContext } from "@/components/layouts/ScoringTableCard/BaseScoringTableContext";

const { ScoringTableProvider } = createScoringTableContext();

const transformStakeholdersResponse = (
  data: ScoringForDirectReportsResponse
): ScoringTableDataRow[] => {
  const stakeholdersData = data.keyStakeholdersMappingScore?.data
    .directReports as DirectReportScoringData[];
  if (!stakeholdersData) return [];

  return stakeholdersData.map((scoringData: DirectReportScoringData) => ({
    user: { id: scoringData.id } as UserData,
    summaryValue: scoringData.avgScore,
    scoreIndicator: [scoringData.directReportsNum, scoringData.weakDealsNum, 0]
  }));
};

export const StakeholdersMappingProvider: React.FC<{
  children: React.ReactNode;
  leadUser: UserData | undefined;
  period?: SettingsPeriod;
}> = ({ children, leadUser, period }) => (
  <ScoringTableProvider
    leadUser={leadUser}
    period={period}
    reportType={ReportType.KEY_STAKEHOLDERS_MAPPING_SCORE}
    transformResponse={transformStakeholdersResponse}
  >
    {children}
  </ScoringTableProvider>
);
